export const useIsNumeric = () => {
    const isNumeric = (value) => {
        const numericRegex = /^[0-9]+$/;
        return numericRegex.test(value);
    };

    return isNumeric;
};
